import { LOCATION_CHANGE } from 'react-router-redux';

import * as organizationConstants from '../constants/organizations';
import * as bucketConstants from '../constants/buckets';
import * as appDialogConstants from '../constants/appDialog';

export default function appDialog(
    state = {
        isOpen: false,
    },
    action,
) {
    switch (action.type) {
        case LOCATION_CHANGE:
        case appDialogConstants.CLOSE_ACTION_DIALOG:
        case organizationConstants.CHANGE_USERS_ROLE_SUCCESS:
        case organizationConstants.REMOVE_USERS_SUCCESS:
        case bucketConstants.ADD_USERS_TO_BUCKETS_SUCCESS:
        case bucketConstants.CHANGE_USERS_ROLE_SUCCESS:
        case bucketConstants.REMOVE_USERS_SUCCESS:
            return {
                isOpen: false,
            };
        case appDialogConstants.OPEN_ACTION_DIALOG:
            return {
                isOpen: true,
                usersIds: action.payload.usersIds,
                action: action.payload.action,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/appDialogReducer.js